import React, {Fragment, useMemo} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import GroheFeatureLockedBadge from "../groheFeature/groheFeatureLockedBadge";
import GroheFeatureOptions from "../groheFeature/groheFeatureOptions";
import LookFeatureOptions from "../../../lookNavigation/lookMain/lookFeature/lookFeatureOptions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {isInStock} from "../../../lookNavigation/lookFunctions2";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {getFeatureOptions} from "../../../lookNavigation/lookFunctions";
import GroheFeatureQuantity from "../groheFeature/groheFeatureQuantity";
import LookWizardContentTitle from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentTitle";
import LookWizardContentDescription from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentDescription";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";

const GroheWizardContentSingleFeature = (props) => {

  const {feature, wizardGroup, filterGroups} = props;

  const showPriceLocked = getFeatureIsLocked(feature);

  const colorOptions = getFeatureOptions(feature, filterGroups);

  const featureIsInStock = useMemo(() => isInStock(feature), [feature]);

  return (
    <div className={"grohe-feature grohe-wizard__feature" + (colorOptions && colorOptions.length ? " grohe-wizard__feature--with-options" : "")}>
      <LookFeatureImage forFeature={feature}/>
      {showPriceLocked ? (
        <GroheFeatureLockedBadge/>
      ) : (
        <Fragment>
          <h2 className="grohe-section__title grohe-section__title--full grohe-section__title--wizard">
            <LookWizardContentTitle/>
          </h2>
          <p className="grohe-section__description grohe-section__description--full grohe-section__description--wizard">
            <LookWizardContentDescription/>
          </p>
        </Fragment>
      )}
      <div className="grohe-wizard__feature-block">
        <LookFeatureOptions isWizard={true}
                            activeFeature={feature}
                            wizardGroup={wizardGroup} />
        {wizardGroup.multipleAddToCart && !feature.dbFeature.hideQuantity
          ? <GroheFeatureQuantity disabled={!featureIsInStock} feature={feature} isWizard={true}/>
          : null}
      </div>
      <GroheFeatureOptions isWizard={true}
                           activeFeature={feature}
                           wizardGroup={wizardGroup}/>
    </div>
  )

};

GroheWizardContentSingleFeature.propTypes = {
  feature: PropTypes.shape(featureInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {filterGroups} = store.filterState;

  return {
    wizardActiveStep,
    wizardSelectedValues,
    filterGroups,
  };
};

export default connect(mapStateToProps)(GroheWizardContentSingleFeature)
